/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: Authenticated.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 111
 * ---
 * Description:
 */

import React, { useEffect } from 'react';
import { useDispatch }      from 'react-redux';
import { me }               from '../../../store/actions/auth-actions';

export class AuthContext {
  private _done: boolean = false;

  public get done() {
    return this._done;
  }

  public set done(value) {
    this._done = value;
  }
}

export class AuthContextProvider {
  private static _context: AuthContext;

  public static getInstance() {
    if (!AuthContextProvider._context)
      AuthContextProvider._context = new AuthContext();

    return AuthContextProvider._context;
  }
}

export const Authenticated = (props: { children: any; }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!AuthContextProvider.getInstance().done) {
      dispatch(me());

      AuthContextProvider.getInstance().done = true;
    }
  }, [AuthContextProvider.getInstance().done]);

  return props.children;
};
